import React from 'react';
import { Box, Flex, Icon, IconButton, useMediaQuery } from '@chakra-ui/react';
import { BellIcon, HamburgerIcon } from '@chakra-ui/icons';
import { MdHome } from 'react-icons/md';
import ProfileMenu from '../../components/global/profileMenu';
import { ChakraProvider } from '@chakra-ui/react';

const Header = ({ userName, userEmail, onMenuClick, onHomeClick, onProfileClick }) => {
  const [isLargerThan768] = useMediaQuery("(min-width: 768px)");

  const handleIconClick = () => {
    if (isLargerThan768) {
      onHomeClick(); // Call the onHomeClick prop when in full screen
    } else {
      onMenuClick(); // Toggle sidebar in compact mode
    }
  };

  return (
    <ChakraProvider>
      <Box bg="#F5F6F8" p={0} boxShadow="md">
        <Flex justify="space-between" align="center">
          {/* Menu/Home Icon on the Left */}
          <Box p={2} ml={2} display="flex" alignItems="center">
            <IconButton
              icon={isLargerThan768 ? <Icon as={MdHome} boxSize={6} /> : <HamburgerIcon boxSize={6} />}
              boxSize={6} // Increase the size of the button
              color="blue.500"
              variant="ghost"
              onClick={handleIconClick}
              aria-label={isLargerThan768 ? "Go to Home" : "Toggle Sidebar"}
            />
          </Box>

          {/* Right Side Icons */}
          <Flex align="center">
            {/* Notification Icon */}
            <Box p={2} display="flex" alignItems="center">
              <Icon as={BellIcon} boxSize={6} color="blue.500" />
            </Box>

            {/* Profile Section */}
            <Box p={2} display="flex" alignItems="center">
              <ProfileMenu 
                name={userName} 
                email={userEmail} 
                onProfileClick={onProfileClick}
              />
            </Box>
          </Flex>
        </Flex>
      </Box>
    </ChakraProvider>
  );
};

export default Header;
